import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { Hero, Section, CTA } from "../components/Page/Page.js";
import Markdown from "../lib/markdown.js";
import { posts } from "../data/posts.js";

const fmt = (d) => new Date(d + "T00:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function PostScreen() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/404" replace />;
  return (
    <>
      <Hero eyebrow={`${post.tag} / ${fmt(post.date)}${post.author ? " / " + post.author : ""}`} title={post.title} text={post.excerpt} image={post.image} />
      <Section>
        <div className="pg-article">
          <Markdown source={post.body} />
          <p><Link to="/insights">← All insights</Link></p>
        </div>
      </Section>
      <CTA />
    </>
  );
}
